import IngredientImagePlaceholder1 from "../assets/images/ingredient-placeholders/IngredientImagePlaceholder1.png";
import IngredientImagePlaceholder2 from "../assets/images/ingredient-placeholders/IngredientImagePlaceholder2.png";
import IngredientImagePlaceholder3 from "../assets/images/ingredient-placeholders/IngredientImagePlaceholder3.png";
import FallbackProductImage from "../assets/images/ingredient-placeholders/fallback_product_img.png";
import FallbackIngredientImage from "../assets/images/ingredient-placeholders/fallback_Ingredient_img.png";
import React from "react";
import config from "./config";
import {
	ICountryData,
	IIngredient,
	IIngredientAddFormData,
	IIngredientFormData
} from "../interfaces/ingredient";
import { IOption } from "../components/form/Select";
import { ICountry } from "../interfaces/country";

export const IngredientNutrientsArray = [
	"df_energy_kcal",
	"df_protein",
	"df_total_lipid",
	"df_carbohydrate",
	"df_fiber",
	"df_sugar",
	"df_calcium",
	"df_vitamin_d2_d3",
	"df_vitamin_c",
	"df_cholesterol",
	"df_fatty_acid_total_saturated",
	"df_fatty_acid_total_trans",
	"df_iron",
	"df_potassium",
	"df_sodium"
];

export const IngredientCategories: { [index: string]: string[] } = {
	ingredients: [
		"Beverages",
		"Dairy",
		"Oils and Fat",
		"Plant-Based",
		"Grains",
		"Fruits & Vegetables",
		"Animal/Insect-Based",
		"Sweetener",
		"Nutrition",
		"Functional"
	],
	additives: ["Shelf-Life", "Taste", "Texture", "Color", "Processing Aids"]
};

export const getIngredientImagePlaceholder = () => {
	return FallbackIngredientImage;
};

export const getProductImagePlaceholder = () => {
	return FallbackProductImage;
};

/**
 * Get ingredient image URL with fallback
 * If ingredient has image_url, use it. Otherwise, return fallback image directly
 * to avoid showing "photo coming soon" placeholders from the API
 * 
 * @param ingredientOrName - Either an ingredient object with image_url property, or just a string name
 * @returns Image URL or fallback image
 */
export const getIngredientImageUrl = (ingredientOrName: { image_url?: string; jf_display_name?: string; name?: string } | string) => {
	// If it's an object and has image_url, use it
	if (typeof ingredientOrName === 'object' && ingredientOrName.image_url && ingredientOrName.image_url.trim() !== "") {
		return ingredientOrName.image_url;
	}
	// Return fallback image directly instead of API endpoint to avoid "photo coming soon" placeholders
	return FallbackIngredientImage;
};

export const formatIngredientFormData = (
	data: IIngredientFormData | IIngredientAddFormData,
	currentIngredient: IIngredient | null
): any => {
	//Don't include market values that aren't tagged for removal & are already included in an ingredients country_data
	const updated_markets = data.available_markets.filter(
		(val: { id: string; remove_id: string }) =>
			currentIngredient?.available_markets?.find((c: ICountry) => c.id == val.id) == undefined
	);

	const { country_data, ...rest } = data;

	let formattedData = {
		...rest,
		name: data.jf_display_name, // Maintain name and jf_display_name equality when updating ingredient
		food_group: data?.food_group?.map((option: IOption) => option.label) || [],
		available_markets: updated_markets
	};
	return formattedData;
};
